// Tyler.API.Searching.FacetType
export enum FacetType {
    Multiselect = 0,
    Range = 1
}
